import React, { useState } from 'react';
import '../Styles/global.css';
import Layout from "../Components/Layout";

const ContentManager = () => {
    return (
        <Layout>
            <div>
                <RecipeManager />
                <ChefManager />
            </div>
        </Layout>
    );
};

const RecipeManager = () => {
    const [recipe1, setRecipe1] = useState('');
    const [recipe2, setRecipe2] = useState('');
    const [recipe3, setRecipe3] = useState('');
    const [notification, setNotification] = useState('');

    const handleAddRecipe = () => {
        if (recipe1.trim() || recipe2.trim() || recipe3.trim()) {
            setNotification('Recepten toegevoegd!');
            setRecipe1(''); // Clear the input fields
            setRecipe2(''); // Clear the input fields
            setRecipe3(''); // Clear the input fields
            setTimeout(() => {
                setNotification('');
            }, 3000); 
        }
    };

    return (
        <div className="recipe-dashboard">
            <h1>Recepten Dashboard</h1>
            <div className="recipe-form-group">
                <textarea
                    value={recipe1}
                    onChange={(e) => setRecipe1(e.target.value)}
                    className="recipe-input-field"
                    placeholder="Recept van de Week 1"
                ></textarea>
                <textarea
                    value={recipe2}
                    onChange={(e) => setRecipe2(e.target.value)}
                    className="recipe-input-field"
                    placeholder="Recept van de Week 2"
                ></textarea>
                <textarea
                    value={recipe3}
                    onChange={(e) => setRecipe3(e.target.value)}
                    className="recipe-input-field"
                    placeholder="Recept van de Week 3"
                ></textarea>
                <button onClick={handleAddRecipe} className="recipe-add-button">
                    Toevoegen
                </button>
            </div>
            {notification && <div className="recipe-notification">{notification}</div>}
        </div>
    );
};

const ChefManager = () => {
    const [chef, setChef] = useState('');
    const [notification, setNotification] = useState('');

    const handleAddChef = () => {
        if (chef.trim()) {
            setNotification('Chef toegevoegd!');
            setChef(''); // Clear the input field
            setTimeout(() => {
                setNotification('');
            }, 3000); 
        }
    };

    return (
        <div className="chef-dashboard">
            <h1>Chef Dashboard</h1>
            <div className="chef-form-group">
                <textarea
                    value={chef}
                    onChange={(e) => setChef(e.target.value)}
                    className="chef-input-field"
                    placeholder="Chef van de Week"
                ></textarea>
                <button onClick={handleAddChef} className="chef-add-button">
                    Toevoegen
                </button>
            </div>
            {notification && <div className="chef-notification">{notification}</div>}
        </div>
    );
};

export default ContentManager;
